<template>
  <div class="template w-full">
    <template v-if="errors.length">
      <div class="alert alert-warning">
        <h3>Es fehlen Angaben für das Fahrzeug</h3>
        <p>Bevor aus diesem Fahrzeug ein Angebot erstellt werden kann, müssen die folgenden Daten vervollständigt werden:</p>
        <br>
        <ul>
          <li
            v-for="error in errors"
            :key="error"
          >
            {{ error }}
          </li>
        </ul>

        <div
          v-if="cashSaleVehicle"
          class="text-right"
        >
          <a
            class="btn btn-warning"
            :href="'#/ajax/car_edit/' + cashSaleVehicle.id"
          >Fahrzeug in Bestand anzeigen</a>
        </div>
      </div>
    </template>
  </div>
</template>

<script>


import { mapActions, mapGetters } from 'vuex'
import CarCheck from '../../mixins/car-check'

export default {

  mixins: [CarCheck],

  computed: {
    ...mapGetters([
      'cashSaleVehicle',
      'quickMethod'
    ])
  },

  mounted() {
    /**
     * Clear store completely.
     */
    this.$store.commit('clearCashSaleStore')
    this.$store.commit('clearFinancingStore')
    this.$store.commit('lead/clearLeadStore')


    const data = {
      carId: this.$route.params.carId
    }

    axios.post(`${process.env.VUE_APP_PROVIDER}/car/get`, data).then((response) => {
      this.storeCashSaleVehicle(response.data)
      this.storeQuickMethod('impart')

      if (this.errors.length) {
        return
      }

      this.$router.push({
        name: 'offers.accessories'
      })
    })
  },

  methods: {
    ...mapActions([
      'storeCashSaleVehicle',
      'storeQuickMethod'
    ])
  }
}

</script>
